import {AbstractTransform, TransformInteractionState} from "../abstract-transform";
import {GeometryUtil} from "../../geometry";
import {Feature, Position} from "geojson";
import {SnapPoint} from "../../snap";

export class EditorFeatureTransformScale extends AbstractTransform<TransformInteractionState> {

  public getVertexIcon(): string {
    return 'map-move';
  }

  protected _hasCenter(): boolean {
    return true;
  }

  public transform(state: TransformInteractionState, e: mapboxgl.MapMouseEvent, snapPoint: SnapPoint) {
    let scale = this.getScale(state, snapPoint);
    let scaledFeature = GeometryUtil.scale(this.originalFeature.toGeoJSON() as Feature, scale, state.center);

    this.transformedFeature.setCoordinates((scaledFeature as any).geometry.coordinates);
  }


  public getScale(state: TransformInteractionState, snapPoint: SnapPoint) {
    let newPoint = snapPoint.point as Position;

    let distance = GeometryUtil.pointsDistance(newPoint, state.center);

    let originalDistance = GeometryUtil.pointsDistance(this.originalFeature.getCoordinate(state.dragPath), state.center);

    return distance / originalDistance;
  }
}
